import { createClient, Provider } from 'urql';

import getEnv from '@wetransfer/transfer/config/env';
import Cookie from '@wetransfer/transfer/modules/concorde-cookie';

import { AppConfig } from './core-bundle/config/app-config';

export function fetchOptions(): RequestInit {
  const options: {
    headers?: Record<string, string>;
  } = {
    headers: {
      'X-App-Origin': 'decoupled',
    },
  };

  const currentTeamCookie = Cookie.get(AppConfig.cookies.currentTeam.name);

  if (currentTeamCookie) {
    options.headers['X-Current-Team'] = currentTeamCookie;
  }

  const amplitudeDeviceId = AppConfig.amplitude.getAmplitudeDeviceId();

  if (amplitudeDeviceId) {
    options.headers['X-Amplitude-Device-Id'] = amplitudeDeviceId;
  }

  const amplitudeUser = AppConfig.amplitude.user;

  if (amplitudeUser && amplitudeUser.country) {
    options.headers['X-Amplitude-Country'] = amplitudeUser.country;
  }

  const amplitudeUserAgent = AppConfig.amplitude.getAmplitudeUserAgentInfo();

  if (amplitudeUserAgent) {
    if (amplitudeUserAgent.deviceType)
      options.headers['X-Amplitude-Device-Type'] =
        amplitudeUserAgent.deviceType;

    if (amplitudeUserAgent.deviceFamily)
      options.headers['X-Amplitude-Device-Family'] =
        amplitudeUserAgent.deviceFamily;

    if (amplitudeUserAgent.platform)
      options.headers['X-Amplitude-Platform'] = amplitudeUserAgent.platform;
  }

  const languageCookie = Cookie.get(AppConfig.cookies.overrideLanguage.name);
  options.headers['X-Amplitude-Language'] = languageCookie || 'en';

  if (Object.keys(options.headers).length) return options;

  return {};
}

export const client = createClient({
  url: getEnv().NEXT_PUBLIC_API_URL + '/api/graphql',
  fetchOptions,
});

export { Provider };
